// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import Chip from '@mui/material/Chip'
import Skeleton from '@mui/material/Skeleton'
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'

import Racking from '../../../components/gudang/racking';
import StockGudang from '../../../components/gudang/stock-gudang';
import UsageStock from '../../../components/gudang/usage-stock';
import OpnameStock from '../../../components/gudang/opname-stock';
import OpnameStockNew from '../../../components/gudang/opname-stock-new';
import OpnameKain from '../../../components/gudang/opname-kain';
import DetailMutasi from '../../../components/gudang/detail-mutasi';
import TransferStock from '../../../components/gudang/transfer-stock';
import Bigseller from '../../../components/gudang/bigseller';

import { useSearchParams, useNavigate, useParams } from "react-router-dom";
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../../../components/icon';
import apiUrl from '../../../configs/constant';

export default function Index() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const { id } = useParams();
    const navigate = useNavigate();
    // Ambil value tab dari query param
    const [searchParams] = useSearchParams();
    const currentTab = searchParams.get('tab') || '2';

    // ** State
    const [values, setValues] = useState<string>(currentTab)
    const [idGudang, setIdGudang] = useState<any>(id)
    const [loading, setLoading] = useState<boolean>(true)
    const [warehouse, setWarehouse] = useState<any>(null)

    const handleChangeTab = (event: SyntheticEvent, newValue: string) => {
        navigate(`?tab=${newValue}`);
        setValues(newValue)
    }

    const getData = () => {
        setLoading(true)
        const url = apiUrl.apiUrl + '/mm/gudang/detail/' + id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {

                if (response.data.success) {
                    const data = response.data.data[0]
                    setWarehouse(data)

                    Swal.close()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
            .catch(error => {
                Swal.fire({
                    title: 'Gagal memuat gudang',
                    text: error.response?.data?.message || error.message,
                    icon: 'error'
                })
            })
            .finally(() => setLoading(false))
    }

    useEffect(() => {
        getData()
        setIdGudang(id)
    }, [id])

    useEffect(() => {
        setValues(currentTab)
    }, [currentTab])

    const tabs = [
        { value: '2', label: 'Stock Gudang', icon: 'mdi:warehouse' },
        { value: '3', label: 'Detail Mutasi', icon: 'mdi:folder-arrow-left-right-outline' },
        { value: '4', label: 'Usage', icon: 'mdi:file-document-arrow-right-outline' },
        { value: '5', label: 'Transfer Stock', icon: 'mdi:truck-delivery-outline' },
        ...(id === '12510000003'
            ? [{ value: '8', label: 'Opname Kain', icon: 'mdi:clipboard-text-outline' }]
            : [{ value: '9', label: 'Opname Stock', icon: 'mdi:clipboard-check-outline' }]),
        ...(id === '12510000004'
            ? [{ value: '7', label: 'BigSeller', icon: 'mdi:storefront-outline' }]
            : []),
    ]

    const panelSx = {
        p: { xs: 1.5, md: 3 },
        bgcolor: '#fff',
        minHeight: 420,
    }

    return (
        <Box sx={{ bgcolor: '#f4f6fa', minHeight: '100%', p: { xs: 1.5, md: 3 } }}>
            <Card sx={{ borderRadius: 4, overflow: 'hidden', boxShadow: '0 12px 36px rgba(34, 52, 92, 0.08)' }}>
                <CardContent
                    sx={{
                        p: { xs: 2.5, md: 3.5 },
                        color: 'common.white',
                        background: 'linear-gradient(120deg, #173f8a 0%, #3158d4 55%, #6d83f2 100%)',
                        '&:last-child': { pb: { xs: 2.5, md: 3.5 } }
                    }}
                >
                    <Box display='flex' alignItems='center' justifyContent='space-between' gap={2} flexWrap='wrap'>
                        <Box display='flex' alignItems='center' gap={2}>
                            <Box sx={{ width: 54, height: 54, borderRadius: 3, bgcolor: 'rgba(255,255,255,.15)', display: 'grid', placeItems: 'center' }}>
                                <Icon icon='mdi:warehouse' width={30} />
                            </Box>
                            <Box>
                                <Typography variant='overline' sx={{ opacity: .75, letterSpacing: 1.2 }}>
                                    Warehouse workspace
                                </Typography>
                                {loading ? (
                                    <Skeleton width={230} height={38} sx={{ bgcolor: 'rgba(255,255,255,.2)' }} />
                                ) : (
                                    <Typography variant='h4' fontWeight={800}>{warehouse?.nama_gudang || 'Gudang'}</Typography>
                                )}
                                <Typography variant='body2' sx={{ opacity: .8 }}>
                                    Kode {warehouse?.kode || '-'} | ID {id}
                                </Typography>
                            </Box>
                        </Box>
                        <Chip
                            icon={<Icon icon='mdi:view-dashboard-outline' />}
                            label='Pusat persediaan'
                            sx={{ bgcolor: 'rgba(255,255,255,.16)', color: 'common.white', fontWeight: 700, backdropFilter: 'blur(8px)' }}
                        />
                    </Box>
                </CardContent>

                <Box sx={{ bgcolor: '#fff' }}>
                    <TabContext value={values}>
                        <Box sx={{ px: { xs: 1, md: 2 }, pt: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                            <TabList
                                variant='scrollable'
                                scrollButtons='auto'
                                allowScrollButtonsMobile
                                onChange={handleChangeTab}
                                sx={{
                                    minHeight: 54,
                                    '& .MuiTabs-indicator': { display: 'none' },
                                    '& .MuiTab-root': {
                                        minHeight: 44,
                                        minWidth: 'auto',
                                        px: 2,
                                        mx: .5,
                                        mb: 1.5,
                                        borderRadius: 2.5,
                                        textTransform: 'none',
                                        fontWeight: 700,
                                        color: 'text.secondary',
                                        transition: 'all .2s ease'
                                    },
                                    '& .MuiTab-root.Mui-selected': {
                                        bgcolor: 'primary.main',
                                        color: 'common.white',
                                        boxShadow: '0 6px 16px rgba(49, 88, 212, .24)'
                                    }
                                }}
                            >
                                {tabs.map(tab => (
                                    <Tab
                                        key={tab.value}
                                        value={tab.value}
                                        label={tab.label}
                                        icon={<Icon icon={tab.icon} />}
                                        iconPosition='start'
                                    />
                                ))}
                            </TabList>
                        </Box>
                        <TabPanel value='1' sx={panelSx}>
                            <Racking mmgudangId={idGudang} />
                        </TabPanel>
                        <TabPanel value='2' sx={panelSx}>
                            <StockGudang mmgudangId={idGudang} />
                        </TabPanel>
                        <TabPanel value='3' sx={panelSx}>
                            <DetailMutasi mmgudangId={idGudang} />
                        </TabPanel>
                        <TabPanel value='4' sx={panelSx}>
                            <UsageStock mmgudangId={idGudang} />
                        </TabPanel>
                        <TabPanel value='5' sx={panelSx}>
                            <TransferStock mmgudangId={idGudang} />
                        </TabPanel>
                        <TabPanel value='6' sx={panelSx}>
                            <OpnameStock mmgudangId={idGudang} />
                        </TabPanel>
                        <TabPanel value='7' sx={panelSx}>
                            <Bigseller mmgudangId={idGudang} />
                        </TabPanel>
                        <TabPanel value='8' sx={panelSx}>
                            <OpnameKain mmgudangId={idGudang} />
                        </TabPanel>
                        <TabPanel value='9' sx={panelSx}>
                            <OpnameStockNew mmgudangId={idGudang} />
                        </TabPanel>
                    </TabContext>
                </Box>
            </Card>
        </Box>
    )
}
